"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApmRumLoggerServiceImpl = void 0;
var core_1 = require("@athena-portal/core");
var apm_rum_1 = require("@elastic/apm-rum");
/**
 * Implementation of the ILoggerService using the Elastic APM RUM library.
 * This service provides message logging.
 *
 * Please note that the Elastic APM RUM library is primarily designed
 * for capturing performance metrics and user interactions (transaction).
 * While this service enables logging arbitrary messages, it achieves this by
 * creating new transactions with the type "log-message" for each
 * message to be logged.
 */
var ApmRumLoggerServiceImpl = exports.ApmRumLoggerServiceImpl = /** @class */ (function () {
    function ApmRumLoggerServiceImpl(apm) {
        this.apm = apm !== null && apm !== void 0 ? apm : this.apm;
    }
    /**
     * Log a message with optional contextual information.
     */
    ApmRumLoggerServiceImpl.prototype.log = function (message, context) {
        if (this.apm) {
            // start a new transaction with name = message and type = "log-message".
            var trx_1 = this.apm.startTransaction(message /* trx name */, "log-message" /* trx type */);
            // if context entries are provided, add them to the transaction as labels
            context === null || context === void 0 ? void 0 : context.forEach(function (entry) {
                var _a;
                for (var _i = 0, _b = Object.keys(entry); _i < _b.length; _i++) {
                    var key = _b[_i];
                    var value = entry[key];
                    trx_1 === null || trx_1 === void 0 ? void 0 : trx_1.addLabels((_a = {},
                        _a[key] = value,
                        _a));
                }
            });
            // this workaround ensures that the transaction duration is at least 1 second
            // without this, transactions with very short durations are ignored
            trx_1 === null || trx_1 === void 0 ? void 0 : trx_1.end(trx_1["_start"] + 1);
        }
    };
    ApmRumLoggerServiceImpl = __decorate([
        (0, core_1.injectable)(),
        __metadata("design:paramtypes", [apm_rum_1.ApmBase])
    ], ApmRumLoggerServiceImpl);
    return ApmRumLoggerServiceImpl;
}());
//# sourceMappingURL=ApmRumLoggerServiceImpl.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/services/impl/ApmRumLoggerServiceImpl.js
// module id = 2487
// module chunks = 0